export default __webpack_public_path__ + "static/logo-white-608db71d9ab6348524fc168a320dda1a.svg";